module.exports = __webpack_public_path__ + "static/media/mug-tea.d1297bbe.svg";